const DEFAULT_BASE_URL = 'https://internal.mtrxstudio.ca'

/**
 * Cookieless pageview tracking for MTRX client sites.
 *
 * @param {{ slug: string, baseUrl?: string }} options
 *
 * Sends a beacon on load and on SPA navigation (pushState/replaceState/
 * popstate). The referrer goes only with the first hit — on later in-app
 * navigations it would still hold the original external URL and misattribute
 * every page. Fire-and-forget: never throws, never blocks the page.
 */
export function initTracking({ slug, baseUrl = DEFAULT_BASE_URL }) {
  if (!slug || typeof window === 'undefined' || !('sendBeacon' in navigator)) return
  const url = `${baseUrl.replace(/\/$/, '')}/api/track`
  let lastPath = null
  let firstHit = true

  function send() {
    const path = window.location.pathname
    if (path === lastPath) return
    lastPath = path
    const payload = JSON.stringify({
      slug,
      path,
      referrer: firstHit ? document.referrer : '',
    })
    firstHit = false
    try {
      // text/plain keeps the cross-origin POST preflight-free.
      navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' }))
    } catch {
      // Tracking must never surface errors on the site.
    }
  }

  const wrap = (method) => {
    const original = history[method].bind(history)
    history[method] = (...args) => {
      original(...args)
      send()
    }
  }
  wrap('pushState')
  wrap('replaceState')
  window.addEventListener('popstate', send)
  send()
}
